export default __webpack_public_path__ + "static/media/micromobility.d18cbb3a.svg";